import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useContext, useState } from 'react';
import { APIContext } from '../../Contexts/APIContext';
import SiteTableRowViewModel from "./ViewModels/SiteTableRowViewModel";
import CreateEditSiteDialog from './CreateEditSiteDialog';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
interface IProps {
    orgId: string;
    row: SiteTableRowViewModel;
    refreshData: () => void;
    canArchive: boolean;
}
export default function SiteTableRow({ row, orgId, refreshData, canArchive }: IProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const open = Boolean(anchorEl);

    const { get, showMessage } = useContext(APIContext);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        setDialogOpen(true);
        handleClose();
    };

    const closeEditDialog = (refresh: boolean) => {
        setDialogOpen(false);
        if (refresh) {
            refreshData();
        }
    };

    const handleLockedToggle = async () => {
        await get('OrganisationSite', `ToggleLockedSite?siteId=${row.id}`);
        showMessage("success", `Site access successfully ${row.locked ? "unlocked" : "locked"}`);
        handleClose();
        refreshData();
    };

    const handleActivateToggle = async () => {
        await get('OrganisationSite', `ToggleActiveSite?siteId=${row.id}`);
        showMessage("success", `Invoicing Successfully ${row.active ? "Disabled" : "Enabled"}`);
        handleClose();
        refreshData();
    };

    const handleArchive = async () => {
        await get('OrganisationSite', `ArchiveSite?siteId=${row.id}`);
        showMessage("success", "Site Successfully Archived");
        handleClose();
        refreshData();
    };

    return (
        <>
            <TableRow sx={!row.locked ? {} : { backgroundColor: "555" }}> {/*active or locked here?*/}
                <TableCell>
                    <Typography>{row.officeName + (row.locked ? " - Access Locked" : "")}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{row.town}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{row.region}</Typography>
                </TableCell>
                <TableCell>
                    <Typography>{row.country}</Typography>
                </TableCell>
                <TableCell>
                    <IconButton size="small" onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                        <MenuItem onClick={handleEdit}>Edit</MenuItem>
                        <MenuItem onClick={handleArchive} disabled={row.adminSite || !canArchive}>Archive</MenuItem>
                        <MenuItem onClick={handleLockedToggle}>{!row.locked ? 'Lock Access' : 'Unlock Access'}</MenuItem>
                        <MenuItem onClick={handleActivateToggle}>{row.active ? 'Disable Invoice' : 'Enable Invoicing'}</MenuItem>
                    </Menu>
                </TableCell>
            </TableRow >
            <CreateEditSiteDialog open={dialogOpen} onClose={closeEditDialog} site={row} orgId={orgId} refreshData={refreshData} />
        </>
    );


}
